module.exports = __webpack_public_path__ + "img/elise.a618986e.webp";